module.exports = __webpack_public_path__ + "static/media/gallery_lac.f8a0118d.png";